import React from "react";
import AppReviews from "../components/AppReviews/AppReviews";

const AppReviewsPage = () => {
  return <AppReviews />;
};

export default AppReviewsPage;
